export function event(action: string, params: Record<string, unknown>): void {
  if (typeof window.gtag === 'function') {
    window?.gtag('event', action, params)
  }
}
